import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["authenticatedUrl"];
import { initialState as authInitialState } from '../initialState';
export const isAuthRoute = (path, routes) => {
  const _authInitialState$rou = _extends({}, authInitialState.routes, routes),
    authRoutes = _objectWithoutPropertiesLoose(_authInitialState$rou, _excluded);
  return Object.values(authRoutes).includes(path);
};